export const whiteTextsColor = '#1a2127';
export const primaryBackgroundColor = '#fff';
export const secondaryBackgroundColor = '#fff';
export const secondaryTextColor = '#506274';
export const activeBackgroundIconColor = '#fff';

export const fontFamily = "Open Sans, sans-serif";

